import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import useImagePath from '~/composables/useImagePath';

/**
 * Generates an optimized background-image url for the given image.
 *
 * @param      {String}  cloudinaryDomain  The Cloudinary domain
 * @param      {String}  imgUrl      The image url
 * @return     {String}  An `url` property that can be used in a `background-image`
 */
export function generateTwicPicBackgroundImage(cloudinaryDomain, imgUrl) {
  var baseDomainRef = ref(cloudinaryDomain);
  var imgUrlRef = ref(imgUrl);
  if (!baseDomainRef.value || !imgUrlRef.value) return '';
  var imagePath = useImagePath(imgUrlRef.value);
  return "url(".concat(baseDomainRef.value, "/d_default_placeholder.png/c_limit,q_auto,f_auto,w_2000/v1/").concat(imagePath, ")");
}

/**
 * Generates a responsive background-image for the given image.
 *
 * @param      {String}  cloudinaryDomain  The Cloudinary domain
 * @param      {String}  imgUrl      The image url
 * @param      {Integer}  width       The img width
 * @return     {String}  An `image-set` property that can be used in a `background-image`
 */
export function generateTwicPicBackgroundImageSet(cloudinaryDomain, imgUrl, width) {
  var baseDomainRef = ref(cloudinaryDomain);
  var imgUrlRef = ref(imgUrl);
  var widthRef = ref(width);
  if (!baseDomainRef.value || !imgUrlRef.value) return '';
  var imagePath = useImagePath(imgUrlRef.value);
  var imgWidth = parseInt(widthRef.value);
  if (isNaN(imgWidth)) return generateTwicPicBackgroundImage(baseDomainRef, imgUrlRef);
  var size = imgWidth;
  var src = "url(\"".concat(baseDomainRef.value, "/d_default_placeholder.png/c_scale,q_auto,f_auto,w_").concat(size, "/v1/").concat(imagePath, "\") 1x");
  var size2x = imgWidth * 2;
  var src2x = "url(\"".concat(baseDomainRef.value, "/d_default_placeholder.png/c_scale,q_auto,f_auto,w_").concat(size2x, "/v1/").concat(imagePath, "\") 2x");
  var size3x = imgWidth * 3;
  var src3x = "url(\"".concat(baseDomainRef.value, "/d_default_placeholder.png/c_scale,q_auto,f_auto,w_").concat(size3x, "/v1/").concat(imagePath, "\") 3x");
  var size4x = imgWidth * 4;
  var src4x = "url(\"".concat(baseDomainRef.value, "/d_default_placeholder.png/c_scale,q_auto,f_auto,w_").concat(size4x, "/v1/").concat(imagePath, "\") 4x");
  var srcset = [src, src2x, src3x, src4x];
  return "-webkit-image-set(".concat(srcset.join(','), ")");
}